"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
let ReopenPageConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.reopenPage = false;
    this.autoOpen = false;
    this.flowSaving = false;
    this.flow_saving_size = 10;
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        const reopen_page = yield API.get(
          `api://base.local/storages/preference/ReopenPages`
        );
        this.reopenPage = reopen_page.data.value.reopenPages;
      } catch (e) {
        let reopen_pages = false;
        yield API.put(`api://base.local/storages/preference/ReopenPages`, {
          reopenPages: reopen_pages
        });
        this.reopenPage = reopen_pages;
      }
      try {
        const auto_open = yield API.get(
          `api://base.local/storages/preference/openShopUrl`
        );
        this.autoOpen = auto_open.data.value.openShopUrl;
      } catch (e) {
        let auto_open = false;
        yield API.put(`api://base.local/storages/preference/openShopUrl`, {
          openShopUrl: auto_open
        });
        this.autoOpen = auto_open;
      }
      yield this.initFlowSaving();
      yield this.initFlowSavingSize();
    });
  }
  initFlowSaving() {
    return __async(this, null, function* () {
      try {
        const auto_open_login = yield API.get(
          `api://base.local/storages/preference/flowSaving`
        );
        this.flowSaving = auto_open_login.data.value.flowSaving;
      } catch (e) {
        let auto_start = false;
        yield API.put(`api://base.local/storages/preference/flowSaving`, {
          flowSaving: auto_start
        });
        this.flowSaving = auto_start;
      }
    });
  }
  initFlowSavingSize() {
    return __async(this, null, function* () {
      try {
        const flow_saving_size_response = yield API.get(
          `api://base.local/storages/preference/flowSavingSize`
        );
        this.flow_saving_size = flow_saving_size_response.data.value.flowSavingSize;
      } catch (e) {
        const _flow_saving_size = 10;
        yield API.put(`api://base.local/storages/preference/flowSavingSize`, {
          flowSavingSize: _flow_saving_size
        });
        this.flow_saving_size = _flow_saving_size;
      }
    });
  }
  changeAutoOpen() {
    return __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/openShopUrl`, {
        openShopUrl: this.autoOpen
      });
    });
  }
  changeReopenPage() {
    return __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/ReopenPages`, {
        reopenPages: this.reopenPage
      });
    });
  }
  changeFlowSaving() {
    return __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/flowSaving`, {
        flowSaving: this.flowSaving
      });
    });
  }
  handleFlowSavingChange() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/flowSavingSize`, {
          flowSavingSize: this.flow_saving_size
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
};
__decorateClass([
  Debounce(500)
], ReopenPageConfig.prototype, "changeAutoOpen", 1);
__decorateClass([
  Debounce(500)
], ReopenPageConfig.prototype, "changeReopenPage", 1);
__decorateClass([
  Debounce(500)
], ReopenPageConfig.prototype, "changeFlowSaving", 1);
__decorateClass([
  Debounce(500)
], ReopenPageConfig.prototype, "handleFlowSavingChange", 1);
ReopenPageConfig = __decorateClass([
  Component({
    components: {}
  })
], ReopenPageConfig);
export {
  ReopenPageConfig as default
};
